import { createEsuitePlatformClient, EsuitePlatformClient } from 'esuite-platform-client';
(window as any).platformApi = createEsuitePlatformClient({
  domain: 'http://localhost:3100',
});
export const getEsuitePlatformApi = () => {
  return (window as any).platformApi as EsuitePlatformClient;
};
